import { Wallet } from 'lucide-react'

export default function WalletIcon() {
  return <Wallet size={24} strokeWidth={2} />
}

export function WalletAlternativeIcon() {
  return <Wallet size={48} strokeWidth={2} />
}
